import { c as _c } from "react/compiler-runtime";
import { Drawer } from '@onefootprint/ui';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import FilterButton from '@/components/filter-button';
import Chips from './components/chips';
import List from './components/list';
import SearchList from './components/search-list';
import Section from './components/section';
type FiltersDrawerProps = {
  /** Filters applied in the URL, shown on the trigger. */
  count: number;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onApply: () => void;
  onClear: () => void;
  children: ReactNode;
};
const FiltersDrawer = t0 => {
  const $ = _c(34);
  const {
    count,
    open,
    onOpenChange,
    onApply,
    onClear,
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "components.filtersDrawer"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("common", t1);
  let t2;
  if ($[1] !== onOpenChange) {
    t2 = () => onOpenChange(true);
    $[1] = onOpenChange;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = count > 0;
  let t4;
  if ($[3] !== count || $[4] !== t) {
    t4 = count > 0 ? t(_temp, {
      count
    }) : t(_temp2);
    $[3] = count;
    $[4] = t;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t2 || $[7] !== t3 || $[8] !== t4) {
    t5 = <FilterButton onClick={t2} hasFilters={t3}>{t4}</FilterButton>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t) {
    t6 = t(_temp3);
    $[10] = t;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== onOpenChange) {
    t7 = () => onOpenChange(false);
    $[12] = onOpenChange;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t) {
    t8 = t(_temp4);
    $[14] = t;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== onApply || $[17] !== t8) {
    t9 = {
      label: t8,
      onClick: onApply
    };
    $[16] = onApply;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t) {
    t10 = t(_temp5);
    $[19] = t;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== onClear || $[22] !== t10) {
    t11 = {
      label: t10,
      onClick: onClear
    };
    $[21] = onClear;
    $[22] = t10;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== children || $[25] !== open || $[26] !== t11 || $[27] !== t6 || $[28] !== t7 || $[29] !== t9) {
    t12 = <Drawer title={t6} open={open} onClose={t7} primaryButton={t9} linkButton={t11}>{children}</Drawer>;
    $[24] = children;
    $[25] = open;
    $[26] = t11;
    $[27] = t6;
    $[28] = t7;
    $[29] = t9;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  if ($[31] !== t12 || $[32] !== t5) {
    t13 = <>{t5}{t12}</>;
    $[31] = t12;
    $[32] = t5;
    $[33] = t13;
  } else {
    t13 = $[33];
  }
  return t13;
};
export default Object.assign(FiltersDrawer, {
  Section,
  Chips,
  List,
  SearchList
});
function _temp($) {
  return $.triggerWithCount;
}
function _temp2($_0) {
  return $_0.trigger;
}
function _temp3($_1) {
  return $_1.title;
}
function _temp4($_2) {
  return $_2.apply;
}
function _temp5($_3) {
  return $_3.clearAll;
}